export default [
  // APP反馈
  {
    path: '/help',
    component: () => import('@/views/help/Index.vue'),
    name: 'help',
    meta: {
      translateKey: 'cfmoto.helpAndFeedback',
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-light-gray',
    },
  },
  // APP反馈详情
  {
    path: '/help-detail-:id',
    component: () => import('@/views/help/Detail.vue'),
    name: 'help-detail',
    meta: {
      translateKey: 'cfmoto.importDetails',
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-light-gray',
    },
  },
];
